var classof = require('../internals/classof');
var hasOwn = require('../internals/has-own-property');
var wellKnownSymbol = require('../internals/well-known-symbol');
var Iterators = require('../internals/iterators');

var ITERATOR = wellKnownSymbol('iterator');
var $Object = Object;

module.exports = function (it) {
  var O = $Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    || hasOwn(Iterators, classof(O));
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/internals/is-iterable.js
// module id = 594
// module chunks = 0 1